import React from 'react';
import { motion } from 'framer-motion';
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
};
const CHECKOUT_URL = 'https://pay.hotmart.com/V106838080C';

/** Large sage-green uppercase call-to-action button used throughout the page. */
export function CtaButton({
  children,
  className = ''
}: CtaButtonProps) {
  return <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex w-full items-center justify-center rounded-full bg-sage px-6 py-4 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-sage/30 transition-colors hover:bg-sage-deep focus:outline-none focus-visible:ring-4 focus-visible:ring-sage/40 sm:text-lg md:px-10 md:py-5 md:text-xl ${className}`} data-id="element-122" data-mp="cjhkaflj3yo5">
      {children}
    </motion.a>;
}